<a id="btn-collapse" class="sidebar-collapser"><i class="ri-arrow-left-s-line"></i></a>
<div class="image-wrapper">
    <img src="assets/pro-sidebar-template/sidebar-bg.jpg" alt="sidebar background" />
</div>
<div class="sidebar-layout">
    <div class="sidebar-header">
        <div class="pro-sidebar-logo" (click)="navigateToDashboard()" style="cursor: pointer;">

            <div>
                <img src="assets/images/logo-icon.png" alt="sidebar background" />
            </div>
            <h5> <img src="assets/images/logo-text.png" alt="sidebar background" style="width:180px;" /></h5>

        </div>
    </div>
    <div class="sidebar-content">
        <nav class="menu open-current-submenu">
            <ul>
                <!-- <li class="menu-header"><span> GENERAL </span></li> -->
                @for(menu of menus; track menu) {
                    <li class="menu-item"
                        [ngClass]="{'sub-menu': (menu?.subMenu?.length || 0) > 0, 'active': isActive(menu)}">
                        <a [routerLink]="menu?.link || []"
                            (click)="menu.subMenu?.length ? toggleMenu(menu) : null; $event.preventDefault();">
                            <span class="menu-icon">
                                <i class="{{menu.icon}}"></i>
                            </span>
                            <span class="menu-title" [title]="menu.title">{{menu.title}}</span>
                        </a>
                        <div class="sub-menu-list" *ngIf="(menu?.subMenu?.length || 0) > 0">
                            <ul>
                                <li class="menu-item" *ngFor="let sub of menu.subMenu"
                                    [ngClass]="{'active': activeMenu === sub}">
                                    <a [routerLink]="sub?.link || []">
                                        <span class="menu-title" [title]="sub.title">{{sub.title}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </li>
                }
            </ul>
        </nav>
    </div>
    <!-- <div class="sidebar-footer">
            <div class="footer-box">
                <div>
                    <img class="react-logo"
                        src="../../user-images.githubusercontent.com/25878302/213938106-ca8f0485-3f30-4861-9188-2920ed7ab284.png"
                        alt="react" />
                </div>
                <div style="padding: 0 10px">
                    <span style="display: block; margin-bottom: 10px">Pro sidebar is also available as a react
                        package
                    </span>
                    <div style="margin-bottom: 15px">
                        <img alt="preview badge"
                            src="https://img.shields.io/github/stars/azouaoui-med/react-pro-sidebar?style=social" />
                    </div>
                    <div>
                        <a href="https://github.com/azouaoui-med/react-pro-sidebar" target="_blank">Check it
                            out!</a>
                    </div>
                </div>
            </div>
        </div> -->
</div>